<template>
	<div class="card card-xl-stretch mb-xl-8">
		<!--begin::Header-->
		<div class="card-header border-0">
			<h3 class="card-title fw-bolder text-dark">
				<span class="fa fa-video"></span>&nbsp;&nbsp; Vídeos
			</h3>
		</div>
		<!--end::Header-->

		<!--begin::Body-->
		<div class="card-body pt-0">
			<div class="row">
				<div class="col-md-4">
					<div class="card shadow-sm">
						<div class="card-header">
							<h3 class="card-title">
								Acessando, executando e finalizando uma aula
							</h3>
							<div class="card-toolbar">
								<button
									type="button"
									class="btn btn-sm btn-info video_player"
									data-video-id="449839585"
									data-video_title="Acessando, executando e finalizando uma aula"
									data-video_msg=""
									data-video_src="https://player.vimeo.com/video/449839585"
									data-bs-toggle="modal"
									data-bs-target="#kt_modal_1"
									@click="capturarInformacoes">
									<span class="fa fa-play"></span>
								</button>
							</div>
						</div>
						<div class="card-body p-0">
							<div class="text-center px-4">
								<br />
								<img
									class="mw-100 mh-300px card-rounded"
									alt=""
									src="admin/images/video-01.png" />
							</div>
							<br />
						</div>
					</div>
				</div>

				<div class="col-md-4">
					<div class="card shadow-sm">
						<div class="card-header">
							<h3 class="card-title">Regras de Tempo</h3>
							<div class="card-toolbar">
								<button
									type="button"
									class="btn btn-sm btn-info video_player"
									data-video-id="449839710"
									data-video_title="Regras de Tempo"
									data-video_msg=""
									data-video_src="https://player.vimeo.com/video/449839710"
									data-bs-toggle="modal"
									data-bs-target="#kt_modal_1"
									@click="capturarInformacoes">
									<span class="fa fa-play"></span>
								</button>
							</div>
						</div>
						<div class="card-body p-0">
							<div class="text-center px-4">
								<br />
								<img
									class="mw-100 mh-300px card-rounded"
									alt=""
									src="admin/images/video-02.png" />
							</div>
							<br />
						</div>
					</div>
				</div>

				<div class="col-md-4">
					<div class="card shadow-sm">
						<div class="card-header">
							<h3 class="card-title">Realizando-Provas</h3>
							<div class="card-toolbar">
								<button
									type="button"
									class="btn btn-sm btn-info video_player"
									data-video-id="449839496"
									data-video_title="Realizando-Provas"
									data-video_msg=""
									data-video_src="https://player.vimeo.com/video/449839496"
									data-bs-toggle="modal"
									data-bs-target="#kt_modal_1"
									@click="capturarInformacoes">
									<span class="fa fa-play"></span>
								</button>
							</div>
						</div>
						<div class="card-body p-0">
							<div class="text-center px-4">
								<br />
								<img
									class="mw-100 mh-300px card-rounded"
									alt=""
									src="admin/images/video-03.png" />
							</div>
							<br />
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--end::Body-->
	</div>

	<div class="modal fade" tabindex="-1" id="kt_modal_1">
		<div class="modal-dialog modal-lg">
			<div class="modal-content">
				<div class="modal-header">
					<h3 class="modal-title">{{ videoTitle }}</h3>
				</div>
				<div class="modal-body">
					<div class="container">
						<div class="iframe-responsive">
							<iframe
								class="iframe-responsive-item"
								:src="videoSrc"
								allow="autoplay; fullscreen"
								allowfullscreen></iframe>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button
						type="button"
						class="btn btn-light"
						data-bs-dismiss="modal"
						@click="pausarVideo">
						Fechar
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
	import { ref } from 'vue';

	const videoId = ref('');
	const videoTitle = ref('');
	const videoMsg = ref('');
	const videoSrc = ref('');

	const capturarInformacoes = (event) => {
		const button = event.currentTarget;
		videoId.value = button.getAttribute('data-video-id');
		videoTitle.value = button.getAttribute('data-video_title');
		videoMsg.value = button.getAttribute('data-video_msg');
		videoSrc.value = button.getAttribute('data-video_src');
	};

	const pausarVideo = () => {
		const iframe = document.querySelector('iframe');
		var player = new Vimeo.Player(iframe);

		if (iframe) {
			player.pause();
		}
	};
</script>

<style scoped>
.iframe-responsive {
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
}

.iframe-responsive-item {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
</style>
